import { render } from "./eConsentDashboard.vue?vue&type=template&id=722c410c&scoped=true"
import script from "./eConsentDashboard.js?vue&type=script&lang=js"
export * from "./eConsentDashboard.js?vue&type=script&lang=js"

import "./eConsentDashboard.vue?vue&type=style&index=0&id=722c410c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722c410c"]])

export default __exports__